import styles from "./TaxClassSelect.module.css";
import classNames from "classnames";

import type { JSX } from "react";

export type RoundOptionProps = {
  name: string;
  value: number;
  selected: boolean;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
};

const RoundOption = (props: RoundOptionProps): JSX.Element => {
  const { name, value, selected, onChange } = props;
  const classes = classNames(styles.option, { [styles.selected]: selected });

  return (
    <label className={classes}>
      <span className={styles.text}>{value}</span>
      <input
        id={`${name}-${value}`}
        name={name}
        type="radio"
        className={styles.control}
        key={value}
        checked={selected}
        onChange={onChange}
        value={value}
      />
    </label>
  );
};

export { RoundOption };
